<template>
  <div id="home">

    <div class="home-top">
      <div class="header">
        <div class="logo">
          <!-- <img v-if="app"  src="./../../assets/shenma-big.jpg" alt="">
					<img v-else :src="wxHeadImg" alt="微信头像"> -->
          <img src="./../../assets/shenma-big.jpg" alt="">
        </div>
        <div class="header-userInfo">

          <div>
            <!-- <p v-if="app">乐柠通信</p>
						<p v-else>{{ wxNickName }}</p> -->
            <p>乐柠通信</p>
            <div><a style="line-height: 24px;color: #1989fa;font-weight: bold;font-size: 14px;" @click="logoutHandler()">退
                出</a></div>
          </div>

          <div class="iccid-line">
            <p>{{ this.$store.state.recordLoginText }}</p>
            <div>
              <van-icon name="descending" size="18" color="rgb(25, 137, 250)" @click="showIccidList = true" />
            </div>
            <!-- <div>
               <button class="tag-read"  :data-clipboard-text="iccidCopy" @click="copy" background-color='black'>复制</button>
            </div> -->
          </div>

          <p v-if="simInfo.alias">{{ simInfo.supplierTypeName }} - {{ simInfo.alias }} 通道</p>
          <p v-else>{{ simInfo.supplierTypeName }}</p>
        </div>
      </div>

      <div class="flowInfo">
        <canvas id="home_progressBar" width="900" height="900"></canvas>
        <div class="residue-flow">
          <p style="font-size:1rem; padding-bottom: 1rem;">卡状态</p>
          <p style="font-size:1.3rem; padding-bottom: 1rem;">{{ simInfo.cardStateName }}</p>
        </div>
        <div class="flowInfo-bottom">
          <div class="total-flow">
            <p>{{ fluxMtoG(simInfo.flowRate) }}</p>
            <p>总流量/GB</p>
          </div>
          <div class="used-flow">
            <p>{{ fluxMtoG(simInfo.usedFlowRate) }}</p>
            <p>已使用/GB</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 卡片管理 -->
    <van-popup v-model="showIccidList" closeable position="top" style="min-height: 20%; max-height: 50%;">

      <div class="iccid-list">
        <h1>卡片管理</h1>
        <div class="iccid-list-item" v-for="item in iccidList" :key="item.iccid">
          <p v-if="item.simDefault == 0">{{ item.iccid }}</p>
          <p v-else-if="item.simDefault == 1" style="color: #FFA941">
            {{ item.iccid }}
          </p>
          <button v-if="item.simDefault == 0" @click="updateDefaultBindIccidHandler(item.iccid)">设为默认</button>
          <button class="delete-item" @click="deleteBindIccidHandler(item.iccid)">删除</button>
        </div>

      </div>
    </van-popup>
    <!-- 卡片管理 end -->


    <div class="main">
      <div class="content-top">
        <!--  总部微信公众号   -->
        <div class="main-top" v-if="$store.state.isHeadquarterAppid == 'true'">
          <div class="line first-line">
            <p class="packageName">
              <span v-if="simInfo.simPackageList[0]">套餐名称：{{ simInfo.packageName }}</span>
              <span v-else style="color: red">套餐名称：暂未订购套餐</span>
            </p>
            <p class="morePackage">
              <a href="javascript: void(0);" @click="pkgListVisible = true">更 多</a>
            </p>

            <p class="time-line">套餐有效期：{{ simInfo.endTime }}</p>

            <div>
              <div class="freshBtn" @click="getAccount()">
                <img src="@/assets/home/14.png">
              </div>
              <span>￥{{ money_format(userAccount.amount / 100, 2, '.', ',') }}</span>
            </div>
          </div>
          <van-divider :style="{ color: '#1989fa', borderColor: '#1989fa', margin: '5px 0' }" />
          <van-notice-bar color="#1989fa" background="#fff" left-icon="volume-o" :text="notifyContent"
            :style="{ padding: '0' }" mode="link" @click="toMoreNotify()"></van-notice-bar>
        </div>


        <!--  代理商微信公众号   -->
        <div class="main-top" v-else>
          <div class="line first-line">
            <p class="packageName">
              <span v-if="simInfo.simPackageList[0]">套餐名称：{{ simInfo.packageName }}</span>
              <span v-else style="color: red">套餐名称：暂未订购套餐</span>
            </p>
            <p class="morePackage">
              <a href="javascript: void(0);" @click="pkgListVisible = true">更 多</a>
            </p>
            <!-- <p class="p-sim">SIM：{{simInfo.simId}}</p> -->

            <p class="time-line">套餐有效期：{{ simInfo.endTime }}</p>
          </div>
        </div>
      </div>


      <div class="content-bottom">
        <div class="main-bottom">
          <!--  总部微信公众号   -->
          <div v-if="$store.state.isHeadquarterAppid == 'true'">
            <div>
              <a href="javascript: void(0);" @click="toBalanceRecharge()">
                <img src="@/assets/home/12.png" alt="">
                <div class="shadow"></div>
                <span>余额充值</span>
              </a>
            </div>

            <div>
              <a href="javascript: void(0);" @click="toRecharge()">
                <img src="@/assets/home/17.png" alt="">
                <div class="shadow"></div>
                <span>套餐订购</span>
              </a>
            </div>

            <div>
              <a href="javascript:void(0)" @click="buyCard()">
                <img src="@/assets/home/27.png" alt="">
                <div class="shadow"></div>
                <span>在线购买</span>
              </a>
            </div>

            <div v-if="cmccAuth == true">
              <a href="javascript: void(0);" @click="cmccAuths()">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>
            <div v-else-if="cuccAuthShow">
              <a href="javascript:void(0)" @click="cuccAuthShowmethod()">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>

            <div v-else-if="xinkeweiFlg">
              <a href="javascript:void(0)" @click="toXinkeweiAuth()">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>
            <div v-else-if="guangdianAuth">
              <a href="javascript:void(0)" @click="toGuangdain()">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>

            <div v-else-if="ctccAuthShow">
              <a href="javascript:void(0)" @click="ctccAuthShowmethod()">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>
            <div v-else-if="qianhailiantongTrue">
              <a :href="qianhaiUrls">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>
            <div v-else>
              <a
                :href="`#/user/verified?state=${state}&supplierTypeCode=${simInfo.supplierTypeCode}&realNameCard=${simInfo.realNameCard}`">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>

            <div>
              <a href="javascript: void(0);" @click="analysisHandler()">
                <img src="@/assets/home/11.png" alt="">
                <div class="shadow"></div>
                <span>智能诊断</span>
              </a>
            </div>

            <div>
              <a href="#/user/balanceRechargeRecord">
                <img src="@/assets/home/19.png" alt="">
                <div class="shadow"></div>
                <span>充值记录</span>
              </a>
            </div>



            <div v-if="canChangeCard">
              <a href="javascript:void(0)" @click="toChgCardQuery()">
                <img src="@/assets/home/15.png" alt="">
                <div class="shadow"></div>
                <span>换卡申请</span>
              </a>
            </div>

            <div v-if="alreadyHasAccount">
              <a href="javascript: void(0);" @click="showPasswordPanel = true">
                <img src="@/assets/home/22.png" alt="">
                <div class="shadow"></div>
                <span>修改密码</span>
              </a>
            </div>

            <div v-if="simInfo.supplierCode == '1255311826602684416'">
              <a href="javascript: void(0);" @click="reBind()">
                <img src="@/assets/home/24.png" alt="">
                <div class="shadow"></div>
                <span>机卡重绑</span>
              </a>
            </div>

            <div>
              <a href="#/user/feedback">
                <img src="@/assets/home/25.png" alt="">
                <div class="shadow"></div>
                <span>问题反馈</span>
              </a>
            </div>

            <div>
              <a href="javascript:void(0)" @click="realNameSearch()"
                v-if="realNameList.indexOf(simInfo.supplierCode) != -1 || qianhailiantongTrue">
                <img src="@/assets/home/26.png" alt="">
                <div class="shadow"></div>
                <span>实名查询</span>
              </a>
            </div>
          </div>

          <!--  代理商端  -->
          <div v-else>
            <div>
              <a href="javascript: void(0);" @click="toRecharge()">
                <img src="@/assets/home/17.png" alt="">
                <div class="shadow"></div>
                <span>套餐订购</span>
              </a>
            </div>
            <div v-if="cmccAuth == true">
              <a href="javascript: void(0);" @click="cmccAuths()">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>
            <div v-else>
              <a
                :href="`#/user/verified?state=${state}&supplierTypeCode=${simInfo.supplierTypeCode}&realNameCard=${realNameCard}`">
                <img src="@/assets/home/18.png" alt="">
                <div class="shadow"></div>
                <span>实名登记</span>
              </a>
            </div>

            <div>
              <a href="javascript:void(0)" @click="buyCard()">
                <img src="@/assets/home/27.png" alt="">
                <div class="shadow"></div>
                <span>在线购买</span>
              </a>
            </div>

            <div>
              <a href="javascript: void(0);" @click="analysisHandler()">
                <img src="@/assets/home/11.png" alt="">
                <div class="shadow"></div>
                <span>智能诊断</span>
              </a>
            </div>
            <div>
              <a href="javascript:void(0)" @click="toChgCardQuery()">
                <img src="@/assets/home/15.png" alt="">
                <div class="shadow"></div>
                <span>换卡申请</span>
              </a>
            </div>

            <div>
              <a href="#/user/balanceRechargeRecord">
                <img src="@/assets/home/19.png" alt="">
                <div class="shadow"></div>
                <span>充值记录</span>
              </a>
            </div>

            <div>
              <a href="javascript:void(0)" @click="realNameSearch()"
                v-if="realNameList.indexOf(simInfo.supplierCode) != -1">
                <img src="@/assets/home/26.png" alt="">
                <div class="shadow"></div>
                <span>电信实名查询</span>
              </a>
            </div>
          </div><!--  代理商端 end -->
        </div><!--  main-bottom” class   end  -->
      </div><!--  “content-bottom” class   end  -->
    </div><!--  “main” class   end  -->


    <p class="tip" v-if="showSupplierTip">部分用户如果充值后上不了网，请设置<br>APN：iotdunj.grevpdn.sd，重启便可</p>


    <!-- 修改密码框   -->
    <div class="van-overlay" style="z-index: 1999;" v-show="showPasswordPanel"></div>
    <div class="van-popup van-popup--round van-popup--center changePasswordPanel"
      style="z-index: 2000; min-height: 55%; min-width: 80%;" v-show="showPasswordPanel"
      :style="{ top: passwordPanelTop + '%' }">

      <van-icon name="cross" class="icon-cross" @click="cancelChangePassword()" />

      <!-- 原密码输入框 -->
      <p>原密码：</p>
      <van-password-input :value="oldPassword" :focused="oldPasswordKeyboard" @focus="oldPasswordOnfocus()" />
      <!-- 新密码输入框 -->
      <p>新密码：</p>
      <van-password-input :value="newPassword" :focused="newPasswordKeyboard" @focus="newPasswordOnfocus()" />
      <!-- 原密码输入框 -->
      <p>再次确认：</p>
      <van-password-input :value="confirmPassword" :focused="confirmPasswordKeyboard" @focus="confirmPasswordOnfocus()" />
      <div class="confirmChangePassword">
        <van-button class="confirmChangePasswordBtn" plain hairline type="info" @click="sureToChangePassword()">确
          定</van-button>
      </div>

    </div>

    <!-- 数字键盘 -->
    <van-number-keyboard :z-index="2015" :show="oldPasswordKeyboard" @input="oldPasswordOnInput"
      @delete="oldPasswordOnDelete" @blur="oldPasswordKeyboard = false" />

    <van-number-keyboard :z-index="2015" :show="newPasswordKeyboard" @input="newPasswordOnInput"
      @delete="newPasswordOnDelete" @blur="newPasswordKeyboard = false" />

    <van-number-keyboard :z-index="2015" :show="confirmPasswordKeyboard" @input="confirmPasswordOnInput"
      @delete="confirmPasswordOnDelete" @blur="confirmPasswordKeyboard = false" />
    <!-- 数字键盘 end -->
    <!-- 修改密码框 end  -->


    <!--  更多套餐信息  -->
    <van-popup v-model="pkgListVisible" closeable position="bottom" style="min-height: 35%; max-height: 75%">
      <div class="pkgList">
        <h3 v-show="simInfo.simPackageList[0]">当前套餐:</h3>
        <h3 v-show="!simInfo.simPackageList[0]" style="color: red">当前暂未订购套餐</h3>
        <ul>
          <li v-for="item in simInfo.simPackageList" :key="item.id">
            <p> {{ item.packageName }}</p>
            <div>
              <p>生效时间： {{ item.startTime }}</p>
              <p v-if="new Date(getDateByTimeStr(item.endTime)[0], getDateByTimeStr(item.endTime)[1], getDateByTimeStr(item.endTime)[2], getDateByTimeStr(item.endTime)[3], getDateByTimeStr(item.endTime)[4], getDateByTimeStr(item.endTime)[5]) < new Date()"
                style="color: red;">过期时间： {{ item.endTime }}</p>
              <p v-else>过期时间： {{ item.endTime }}</p>
            </div>
          </li>
        </ul>
      </div>
    </van-popup>
    <!--  更多套餐信息  end -->



    <!--  智能诊断提醒  -->
    <van-dialog v-model="analysisHandlerData.analysisHandlerDialog" class="analysisHandlerDialog" title="诊断完成">
      <p><span>卡号：</span>{{ this.$store.state.recordLoginText }}</p>
      <p>
        <span>当前套餐：</span>
        {{ analysisHandlerData.packageName }}
        <a href="javascript: void(0);" style="color: #1989fa; float: right;" @click="showMoreAfterAnalysis()">更 多</a>
      </p>
      <p><span>剩余流量：</span>{{ fluxMtoG(analysisHandlerData.flowRate - analysisHandlerData.usedFlowRate) }} G</p>
      <p><span>有效期：</span>{{ analysisHandlerData.endTime }}</p>
      <p><span>状态：</span>{{ analysisHandlerData.simState }}</p>
      <p>公众号点击智能诊断，点击更新均可加速复机过程。如果刚充值不满30分钟，请耐心等待即可。</p>
    </van-dialog>
    <!--  智能诊断提醒  end  -->
    <keep-alive>
      <SuspendButton @suspendFn="updateStateRateFlow" />
    </keep-alive>

    <!-- 图片实名认证 -->
    <van-dialog v-model="showimg" title="请扫描下方二维码" show-cancel-button>
      <img style="width:100%;" src="@/assets/suolangunicom.jpg" />
    </van-dialog>
  </div>
</template>

<script>
import { Dialog } from 'vant';
import { Toast } from 'vant';

import { wxRequest } from '@/api/user.js'

import SuspendButton from "@/components/SuspendButton";
import Clipboard from 'clipboard';
export default {
  components: { SuspendButton },
  name: 'home',
  data() {
    return {
      xinkeweiFlg: false,
      xinkeweiList: ['1761027174137065472'],
      cmccAuth: false,
      cmccAuthList: ['1510177810235256832', '1565523714760503296', '1632271033769652224', '1796003270817214464'],
      app: localStorage.getItem("app"),
      iccidCopy: '',
      state: '',
      stateName: '',
      wxHeadImg: localStorage.getItem('wxHeadImg'),
      wxNickName: localStorage.getItem('wxNickName'),
      showSupplierTip: false,//

      simInfo: {
        simId: '',
        simPackageList: [],
        supplierTypeCode: "",
        packageName: null,
        endTime: null
      },

      userAccount: {
        amount: 0,
      },
      notifyContent: "余额充值赠送活动火爆上线啦，充得多送得多喔。",
      alreadyHasAccount: false,
      canChangeCard: false,//是否可申请换卡

      userInfo: {
        oldIccid: '',
        takeNickname: '',
        takePhone: '',
        takeAddress: '',
        disposeState: '',
        disposeRemark: '',
        changeCmccSim: 6,
        changeCmccSimName: '',
        pcaAddress: ''
      },

      //修改密码
      showPasswordPanel: false,

      oldPasswordKeyboard: false,
      newPasswordKeyboard: false,
      confirmPasswordKeyboard: false,

      oldPassword: '',
      newPassword: '',
      confirmPassword: '',
      passwordPanelTop: 50,
      //修改密码 end

      pkgListVisible: false,


      //卡片管理弹出层列表
      showIccidList: false,
      iccidList: [],
      refreshIccidList: true,
      defaultIccid: localStorage.getItem("iccid"),

      //智能诊断提醒 
      analysisHandlerData: {
        analysisHandlerDialog: false,
        iccid: null,
        packageName: null,
        flowRate: null,
        usedFlowRate: null,
        endTime: null,
        simState: null,
      },
      realNameCard: -1,
      realNameList: ['1345569865557078016', '1354311436448296960', '1377609720549863424', '1390574237877530624'],
      suolangList: ['1302856426296700928', '1294560739993841664', '1337205009489588224', '1382231170900553728', '1464115903481245696',
        '1535505221160005632', '1634399992074465280', '1662282060166852608', '1669896217343029248', '1704085587696283648', '1742220017690210304',
        '1742808130271571968', '1761026917630210048'],
      showimg: false,
      cuccAuthShow: false,
      ctccAuthShow: false,
      qianhailiantongTrue: false,
      qianhailiantongList: ['1341273297127469056'],
      qianhaiUrls: 'http://wechat.liuliangka.co/#/user/verifiedOtherQh?iccid=' + localStorage.getItem('iccid'),

      guangdianAuth: false,
      guangdianList: ['1813261838960291840','1868697587956051968'],
    }
  },

  computed: {

  },
  methods: {
    toXinkeweiAuth() {
      window.location.href = 'https://iot.xkwei.com/terminal-web/pages/iccid/iccid_name/index';
    },
    copy() {
      var clipboard = new Clipboard('.tag-read')
      clipboard.on('success', e => {
        console.log('复制成功')
        alert("复制成功");
        clipboard.destroy()// 释放内存
      })
      clipboard.on('error', e => {
        console.log('不支持复制,该浏览器不支持自动复制')
        alert("复制失败")
        clipboard.destroy()// 释放内存
      })
    },
    getUserSimInfo() {
      wxRequest("sim/detail", { iccid: this.$store.state.iccid }, "post").then(res => {
        if (res.data.code == 200) {
          let result = res.data.data;
          if (result.simPackageList.length > 0) {
            wxRequest("applyChangeSim/select/agent/buy/power", { oldIccid: this.$store.state.iccid }, "post").then(res => {
              if (res.data.code == 200 && !sessionStorage.getItem('buyCardDialog')) {
                sessionStorage.setItem('buyCardDialog', true)
                Dialog.confirm({
                  message: '用着不错，不给家人朋友来一张吗？',
                  confirmButtonText: '我要分享',
                  cancelButtonText: '我要独享'
                }).then(() => {
                  this.$router.push('/user/buyCard');
                }).catch(() => {

                });
              }
            })
          }
          /** 临时提示代码 **/
          if (this.realNameList.indexOf(result.supplierCode) != -1) {
            this.ctccAuthShow = true;
            this.realNameCard = this.realNameList.indexOf(result.supplierCode);
            sessionStorage.setItem('realNameCard', this.realNameCard)
            // console.log(this.realNameCard)
            // Dialog.confirm({
            //     title: '提示',
            //     message: '您好，为落实工业和信息化部要求，电信卡用户请进行运营商实名认证后才能正常使用。 请点击【确认】按钮前往实名，如已实名请忽略！'
            // }).then(() => {
            //     this.$router.push({
            //         path:'/user/verified',
            //         query:{
            //             realNameCard: this.realNameCard
            //         }
            //     });
            // }).catch(() => {

            // });
            // sessionStorage.setItem('alreadyCertification', 'true');
          }
          /** 临时提示代码  end  **/

          // setTimeout(() => {
          //   if(this.suolangList.indexOf(result.supplierCode) > -1){
          //     this.cuccAuthShow=true;
          //     sessionStorage.setItem('suolangunicomDialog', true)
          //     this.showimg = true;
          //   }
          // }, 1000);
          if (this.realNameList.indexOf(result.supplierCode) != -1) {
            this.realNameCard = this.realNameList.indexOf(result.supplierCode);

          } else if (this.suolangList.indexOf(result.supplierCode) != -1) {
            this.cuccAuthShow = true;
          } else if (this.qianhailiantongList.indexOf(result.supplierCode) != -1) {
            this.qianhailiantongTrue = true;
          } else if (this.cmccAuthList.indexOf(result.supplierCode) > -1) {
            this.cmccAuth = true
          } else if (this.xinkeweiList.indexOf(result.supplierCode) > -1) {
            this.xinkeweiFlg = true
          } else if (this.guangdianList.indexOf(result.supplierCode) > -1) {
            this.guangdianAuth = true
          }
          wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem('iccid'), intoNo: result.intoNo }, 'post').then(res => {
            // /** 临时提示代码 **/
            // if(res.data.code == 200 && res.data.data.msg == '未实名' && this.realNameCard > -1){
            //       Dialog.confirm({
            //           title: '提示',
            //           message: '您好，为落实工业和信息化部要求，电信卡用户请进行运营商实名认证后才能正常使用。 请点击【确认】按钮前往实名，如已实名请忽略！'
            //       }).then(() => {
            //           this.$router.push({
            //               path:'/user/verified',
            //               query:{
            //                   realNameCard: this.realNameCard
            //               }
            //           });
            //       }).catch(() => {

            //       });
            //       // sessionStorage.setItem('alreadyCertification', 'false');
            // }else if(res.data.code != 200 && this.realNameCard > -1) {
            //     Dialog.confirm({
            //         title: '提示',
            //         message: '您好，为落实工业和信息化部要求，电信卡用户请进行运营商实名认证后才能正常使用。 请点击【确认】按钮前往实名，如已实名请忽略！'
            //     }).then(() => {
            //         this.$router.push({
            //             path:'/user/verified',
            //             query:{
            //                 realNameCard: this.realNameCard
            //             }
            //         });
            //     }).catch(() => {

            //     });
            // }
            /** 临时提示代码  end  **/
          })


          sessionStorage.setItem("supplierCode", result.supplierCode);
          if (result.cardState && result.cardState == 13) {
            Dialog.alert({ title: '提示', message: "该卡已过期，请重新联系您的经销商购买，谢谢!" })
          }

          this.simInfo = result;

          if (result.simPackageList.length > 1) {
            for (let i = 0; i < result.simPackageList.length; i++) {
              if (result.simPackageList[i].flowRatePercent &&
                result.simPackageList[i].flowRatePercent / 100 * result.simPackageList[i].flowRate > result.simPackageList[i].usedFlowRate) {
                this.simInfo.packageName = result.simPackageList[i].packageName;
                this.simInfo.endTime = result.simPackageList[i].endTime;
                break;
              }
            }
          } else if (result.simPackageList.length == 1) {
            this.simInfo.packageName = result.simPackageList[0].packageName;
            this.simInfo.endTime = result.simPackageList[0].endTime;
          }

          this.simInfo.simId = this.simInfo.simPackageList[0] ? this.simInfo.simPackageList[0].simId : '';

          //画流量仪表盘
          let progressRate = this.simInfo.usedFlowRate ? Math.floor((this.simInfo.usedFlowRate / this.simInfo.flowRate) * 100) : 0;
          let fz = 40;
          if (progressRate == 100) {
            fz = 30;
          }
          this.drawProgressBar("home_progressBar", progressRate, 3.14, '#008fd0', '#0765c3', 85, fz, "inner");
        }
      });
    },
    cuccAuthShowmethod() {
      wxRequest("wxAuth//have/pkg", {
        iccid: localStorage.getItem('iccid'),
        intoNo: this.simInfo.intoNo
      }, 'post').then(res => {
        if (res.data.code == 200) {
          Dialog.alert({
            message: '已实名'
          })
        } else if (res.data.code == 404) {
          Dialog.alert({
            message: '请先购买可用套餐，再来进行实名操作！'
          })
        } else {
          window.location.href = 'http://wx.sekj.vip/#/user/cuccAuthUrl?iccid='+localStorage.getItem('iccid');
        }
      })
    },
    toGuangdain() {
      wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem('iccid'), intoNo: this.simInfo.intoNo }, 'post').then(res => {
        if (res.data.code == 200) {
          Dialog.alert({ message: '已实名' })
        }
        else {
          Dialog.confirm({
            title: '实名提示',
            message: "请复制此ICCID：" + this.simInfo.iccid + "，点击确认 去完成实名"
          }).then(() => {
            window.location.href = 'https://m.10099.com.cn/h5wap/busiClient/activateIOTCard/authenticationIccId.html';
          }).catch(() => {

          });
        }
      })

    },
    ctccAuthShowmethod() {
      wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem('iccid'), intoNo: this.simInfo.intoNo }, 'post').then(res => {
        if (res.data.code == 200) {
          Dialog.alert({ message: '已实名' })
        }
        else {
          Dialog.confirm({
            title: '实名提示',
            message: "请复制此ICCID：" + this.simInfo.iccid + "，点击确认 去完成实名"
          }).then(() => {
            window.location.href = 'http://iotapp.iot.189.cn:9090/uapp/certifhtml/certif_entry.html?userCode=r/s9Tc00hjiKcR13MIjZHg==&passWord=9u8VuY1xbez6r6k/BBnLlw==&tmstemp=1581922935504';
          }).catch(() => {

          });
        }
      })

    },


    logoutHandler() {
      localStorage.removeItem('iccid');
      //若为总部微信公众号
      if (this.$store.state.isHeadquarterAppid == 'true') {
        window.location.href = window.location.origin + '/';
      }
      //若为代理商微信公众号
      else {
        window.location.href = window.location.origin + '/?source=' + localStorage.getItem('appid');;
      }

    },

    toChgCardQuery() {
      /**   换卡判断       **/
      let fd = new FormData();
      let oldIccid = localStorage.getItem("iccid");
      fd.append("iccid", oldIccid);
      wxRequest("applyChangeSim/isChange", fd, "post").then(res => {
        if (res.data.code == '200') {
          let cardType = 0;
          if (res.data.data) {
            cardType = res.data.data.cardType;
          }

          this.$router.push({
            name: 'userChgCard',
            query: {
              'oldIccid': oldIccid,
              'changeCmccSim': 2
            }
          })
        }
        else {
          Dialog.alert({ title: '提示', message: res.data.message });
        }
      })

      /**     换卡判断   end    **/
    },


    toRecharge() {
      //若为总部微信公众号
      if (this.$store.state.isHeadquarterAppid == 'true') {
        let fd = new FormData();
        fd.append('supplierId', sessionStorage.getItem("supplierCode"));
        wxRequest("sim/invent/state", fd, "post").then(res => {
          if (res.data.code == 200) {
            if (this.userAccount.amount < 0) {
              Dialog.confirm({
                title: '提示',
                message: '您的账户余额已透支，请先充值账户余额！'
              }).then(() => {
                // on confirm
                this.$router.push({
                  path: '/user/balanceRecharge',
                  query: {
                    iccid: this.$store.state.iccid
                  }
                });
              }).catch(() => {

              });
            }
            else {
              this.$router.push({
                path: '/user/recharge',
                query: {
                  iccid: this.$store.state.iccid
                }
              });
            }
          } else {
            Dialog.alert({ title: '提示', message: res.data.message })
          }
        })
      }

      //若为代理商微信公众号
      else {
        this.$router.push({
          path: '/user/recharge',
          query: {
            iccid: this.$store.state.iccid
          }
        });
      }

    },

    toBalanceRecharge() {

      let fd = new FormData();
      fd.append('supplierId', sessionStorage.getItem("supplierCode"));
      wxRequest("sim/invent/state", fd, "post").then(res => {
        if (res.data.code == 200) {
          this.$router.push({
            path: '/user/balanceRecharge',
            query: {
              iccid: this.$store.state.iccid
            }
          });

        } else {
          Dialog.alert({ title: '提示', message: res.data.message })
        }
      })

    },
    cmccAuths() {
      wxRequest("wxAuth/cmcc/auth", { iccid: localStorage.getItem('iccid'), intoNo: this.simInfo.intoNo }, 'post').then(res => {
        if (res.data.code == 200) {
          window.location.href = res.data.data;
        } else {
          Dialog.alert({ message: res.data.message })
        }

      })
    },

    getAccount() {
      let param = {
        iccid: this.$store.state.iccid,
        mobile: localStorage.getItem('mobile'),
      }
      //若为总部微信公众号
      if (this.$store.state.isHeadquarterAppid == 'true') {
        wxRequest("sysUser/account/querySysUserAccount", param, "post").then(res => {
          if (res.data.code == 200) {
            this.userAccount = res.data.data;
            this.alreadyHasAccount = true;
          } else if (res.data.code == 400) {
            let self = this;

            if (self.$store.state.supplierCode == '1197749413972275200') {

              Dialog.confirm({
                title: '提示',
                message: '首次使用需进行充值，请点击【确认】前往充值'
              }).then(() => {
                // on confirm
                self.$router.push({
                  path: '/user/cardSetUp',
                  query: {
                    iccid: self.$store.state.iccid
                  }
                });
              }).catch(() => {

              });
            }

          }
        });
      }

      //若为代理商公众号
      else {
        wxRequest("sysUser/account/querySysUserAccount", param, "post").then(res => {
          if (res.data.code == 200) {
            this.userAccount = res.data.data;
            this.alreadyHasAccount = true;
          }
        });
      }

    },

    //跳往更多公告页面
    toMoreNotify() {
      this.$router.push({
        path: '/user/notify',
      });
    },

    //一键智能诊断
    analysisHandler() {
      let _this = this;
      let data = new FormData();
      data.append("iccid", this.$store.state.iccid);

      //应后端要求  两次请求
      wxRequest("sim/update/stateRateFlow", data, "post").then(res => {
        wxRequest("sim/select/stateRateFlow/info", data, "post").then(newRes => {
          if (newRes.data.code == 200) {
            let resultList = newRes.data.data.simPkg;
            if (resultList.length > 1) {
              for (let i = 0; i < resultList.length; i++) {
                if (resultList[i].flowRatePercent &&
                  resultList[i].flowRatePercent / 100 * resultList[i].flowRate > resultList[i].usedFlowRate) {
                  for (let key in this.analysisHandlerData) {
                    this.analysisHandlerData[key] = resultList[i][key];
                  }
                  break;
                }
              }
            } else if (resultList.length == 1) {
              for (let key in this.analysisHandlerData) {
                this.analysisHandlerData[key] = resultList[0][key];
              }
            }
            this.analysisHandlerData.simState = newRes.data.data.simState;
            this.analysisHandlerData.analysisHandlerDialog = true;
            this.getUserSimInfo();

          } else {
            Dialog.alert({ title: '提示', message: newRes.data.message });
          }
        });
      })
    },

    showMoreAfterAnalysis() {
      this.analysisHandlerData.analysisHandlerDialog = false;
      this.pkgListVisible = true;
    },

    // 更新状态、流量比
    updateStateRateFlow(isSingleTouch) {
      if (isSingleTouch) {
        let fd = new FormData();
        fd.append("iccid", this.$store.state.iccid);
        wxRequest("sim/select/stateRateFlow", fd, "post").then(res => {
          this.getUserSimInfo();
        })
      }
    },

    //机卡重绑
    reBind() {
      let param = {
        intoNo: this.simInfo.intoNo,
        supplierCode: this.simInfo.supplierCode
      }
      wxRequest('sim/unbind', param, 'post').then(res => {
        if (res.data.message) {
          Dialog.alert({ title: '提示', message: res.data.message })
        }
      })
    },

    //获取绑定的卡片列表
    getBindIccidListHandler() {
      var data = {
        userPhone: localStorage.getItem('mobile')
      }
      wxRequest("bindPhone/list", data, "post").then(res => {
        if (res.data.code == 200) {
          this.refreshIccidList = false;
          this.$nextTick(() => {
            this.refreshIccidList = true;
            this.iccidList = res.data.data;
          })
        } else {
          // Dialog.alert({title:'提示', message: res.data.message})
        }
      })
    },

    //卡片管理
    deleteBindIccidHandler(iccid) {
      Dialog.confirm({ message: '您确定删除吗？' }).then(action => {
        var data = {
          iccid,
          userPhone: localStorage.getItem('mobile')
        }
        wxRequest("bindPhone/delete", data, "post").then(res => {
          if (res.data.code == 200) {
            Toast.success("删除成功");
            if (res.data.data == null || res.data.data.length == 0) {
              window.location.href = window.location.origin + '#/user'
            } else {
              this.getBindIccidListHandler();
              this.showIccidList = false;
            }

          } else {
            Dialog.alert({ title: '提示', message: res.data.message })
          }
        })
      }).catch(() => { });
    },
    updateDefaultBindIccidHandler(iccid) {
      var data = {
        iccid: this.defaultIccid,
        defaultIccid: iccid
      }
      wxRequest("bindPhone/update/default", data, "post").then(res => {
        if (res.data.code == 200) {
          Dialog.alert({ title: '提示', message: "设置成功，将会退出重新登录" }).then(() => {
            localStorage.setItem('iccid', iccid);
            window.location.href = window.location.origin + '/';
          });
        } else {
          Dialog.alert({ title: '提示', message: res.data.message })
        }
      })
    },


    /***   修改密码     ***/
    oldPasswordOnfocus() {
      this.oldPasswordKeyboard = true;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    oldPasswordOnDelete() {
      this.oldPassword = this.oldPassword.slice(0, this.oldPassword.length - 1);
    },

    oldPasswordOnInput(key) {
      this.oldPassword = (this.oldPassword + key).slice(0, 6);
    },


    newPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = true;
      this.confirmPasswordKeyboard = false;
      this.passwordPanelTop = 30;
    },
    newPasswordOnDelete() {
      this.newPassword = this.newPassword.slice(0, this.newPassword.length - 1);
    },

    newPasswordOnInput(key) {
      this.newPassword = (this.newPassword + key).slice(0, 6);
    },


    confirmPasswordOnfocus() {
      this.oldPasswordKeyboard = false;
      this.newPasswordKeyboard = false;
      this.confirmPasswordKeyboard = true;
      this.passwordPanelTop = 30;
    },
    confirmPasswordOnDelete() {
      this.confirmPassword = this.confirmPassword.slice(0, this.confirmPassword.length - 1);
    },

    confirmPasswordOnInput(key) {
      this.confirmPassword = (this.confirmPassword + key).slice(0, 6);
    },


    cancelChangePassword() {
      this.oldPassword = '';
      this.newPassword = '';
      this.confirmPassword = '';
      this.passwordPanelTop = 50;
      this.showPasswordPanel = false;
    },

    sureToChangePassword() {

      if (this.oldPassword.length < 6 ||
        this.newPassword.length < 6 ||
        this.confirmPassword.length < 6) {
        Dialog.alert({ message: "请输入六位密码" });
        return;
      }

      if (this.newPassword != this.confirmPassword) {
        Dialog.alert({ message: "两次输入的新密码不一致" });
        return;
      }


      let data = {
        iccid: this.$store.state.iccid,
        paypassOld: this.oldPassword,
        paypass: this.confirmPassword,

      }
      wxRequest("sysUser/account/user/resetPaypass", data, "post").then(res => {
        if (res.data.code == 200) {
          Toast.success(res.data.message);
          this.cancelChangePassword();
        } else {
          Dialog.alert({ message: res.data.message })
        }
      });
    },
    /***   修改密码  end   ***/



    getDateByTimeStr(timeStr) {
      if (timeStr && typeof (timeStr) === 'string') {
        let dayStr = timeStr.split(' ')[0].split('-');
        let hourStr = timeStr.split(' ')[1].split(':');
        return dayStr.concat(hourStr);
      }
      return timeStr;
    },

    //电信实名查询
    realNameSearch() {
      wxRequest("wxAuth/ctcc/auth", { iccid: localStorage.getItem('iccid'), intoNo: this.simInfo.intoNo }, 'post').then(res => {
        if (res.data.code == 200) {
          Dialog.alert({ message: res.data.data.msg })
        }
        else {
          Dialog.alert({ message: res.data.message })
        }
      })
    },

    //买卡
    buyCard() {
      wxRequest("applyChangeSim/select/agent/buy/power", { oldIccid: localStorage.getItem('iccid') }, 'post').then(res => {
        if (res.data.code == 200) {
          this.$router.push('/user/buyCard')
        }
        else {
          Dialog.alert({ message: res.data.message })
        }
      })
    }

  },
  created() {
    let fd = new FormData();
    fd.append("iccid", localStorage.getItem("iccid"));

    this.$store.state.recordLoginText = localStorage.getItem("recordLoginText");
    var data = {
      iccid: this.$store.state.iccid
    }
    this.iccidCopy = this.$store.state.iccid;
    wxRequest("wxAuth/state", data, "post").then(res => {
      if (res.data.code == 200) {
        if (res.data.data.supplierCode == 'B1E112B9F1D8420E9072D9F47D6A135E') {
          this.showSupplierTip = true;
        } else {
          this.showSupplierTip = false;
        }
        var result = res.data.data;
        this.state = result.authState;
        this.stateName = result.authStateNick;
      }
    });

    //获取绑定的卡片列表
    this.getBindIccidListHandler();

    //获取首条公告
    wxRequest("sim/notice/top", fd, "post").then(res => {
      if (res.data.code == '200') {
        this.notifyContent = res.data.data.content;
      }
    });



  },

  mounted() {

    /**   换卡判断       **/
    let fd = new FormData();
    fd.append("iccid", localStorage.getItem("iccid"));
    // if(this.$store.state.isHeadquarterAppid=='true'){
    wxRequest("applyChangeSim/isChange", fd, "post").then(res => {
      if (res.data.code == '200') {
        this.canChangeCard = true;
        let cardType = 0;
        let cardTypeStr = '电信';
        if (res.data.data) {
          cardType = res.data.data.cardType;
          cardTypeStr = res.data.data.cardType == 0 ? '移动' : res.data.data.cardType == 1 ? '电信' : '联通';
        }

        //公司本部公众号
        if (localStorage.getItem('isHeadquarterAppid') == "true") {
          Dialog.alert({ title: '提示', messageAlign: 'left', message: '尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，我司将免费给您更换网速良好的新卡使用，请填写好您的联系方式和地址，原卡套餐流量将会转移到新卡，感谢您一直以来的支持 ！' })
            .then(action => {
              let cardBeLack = "移动";
              if (cardTypeStr == "移动") {
                cardBeLack = "电信"
              }
              Dialog.confirm({ title: '提示', message: '目前联通卡充足，其它卡缺货(发货时间可能较长)，您确定要换卡吗？' }).then(action => {
                if (action == 'confirm') {
                  this.$router.push({
                    name: 'userChgCard',
                    query: {
                      'oldIccid': localStorage.getItem('iccid'),
                      'changeCmccSim': cardType
                    }
                  })
                }
              }).catch(() => {
              });
            })
        }

        else {
          Dialog.alert({ title: '提示', messageAlign: 'left', message: '尊敬的用户：\n&#12288;&#12288;由于运营商系统故障，此卡已暂停使用，请联系您的经销商，谢谢！' });
        }

      }
    })
    // }

    /**     换卡判断   end    **/


    this.getUserSimInfo();
    this.getAccount();
  },

  beforeRouteLeave(to, from, next) {
    if (to.path == '/user') {
      window.location.href = window.location.origin + '#/user'
    }
    next();
  }
}
</script>



<style lang="less" >
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#home_progressBar {
  position: absolute;
  width: 14.5rem;
  height: 14.5rem;
  top: -25px;
  left: calc(50% - 7.25rem);

}


#home {
  height: 100%;
  background: rgba(246, 246, 246, 1);

  a {
    color: #2c3e50;
  }

  .home-top {
    color: #fff;
    height: 45%;
    background-image: linear-gradient(#9dcae0, #26a2ff);
    background-size: 100% 100%;

    .header {
      display: flex;
      padding: 20px;
      padding-bottom: 5px;

      .logo,
      .header-userInfo {
        display: inline-block;
      }

      .logo {
        margin-right: 20px;

        img {
          width: 65px;
          height: 65px;
          margin-bottom: 10px;
          border-radius: 35px;
          border: 2px solid #fff;
        }
      }

      .header-userInfo {
        width: 100%;

        p {
          line-height: 24px;
          font-size: 16px;
        }

        >div {
          display: flex;

          p {
            flex: 1;
          }

          p:last-child {
            text-align: right;
          }
        }

        .iccid-line {
          display: inline-block;

          div,
          p {
            display: inline-block;
            vertical-align: middle;
          }

          div {
            margin-left: 3px;
          }
        }
      }

    }
  }




  .flowInfo {
    position: relative;
    text-align: center;

    .residue-flow {
      padding-top: 10px;

      p:first-child {
        padding-top: 30px;
        font-size: 38px;
      }

      p:last-child {
        line-height: 18px;
      }
    }

    .flowInfo-bottom {
      display: flex;
      margin-top: 0px;

      .total-flow {
        p:first-child {
          font-size: 24px;
        }

        flex: 1;
      }

      .used-flow {
        p:first-child {
          font-size: 24px;
        }

        flex: 1;
      }

    }

  }

  .iccid-list {
    padding: 30px 15px 10px;
    box-sizing: border-box;

    h1 {
      font-weight: bold;
      text-align: center;
      margin-bottom: 10px;
    }

    .iccid-list-item {
      box-sizing: border-box;
      height: 45px;
      display: flex;
      margin-bottom: 2px;
      border-bottom: 1px solid #f7f7f7;

      p {
        flex: 1;
        line-height: 45px;
        color: #000;
      }

      button {
        margin: 2px 0 0 5px;
        height: 40px;
        width: 70px;
        color: #909399;
        background: #f4f4f5;
        border: 1px solid #d3d4d6;
        border-radius: 5px;
      }

      .delete-item {
        color: #f56c6c;
        background: #fef0f0;
        border: 1px solid #fbc4c4;
        border-radius: 5px;
      }
    }

    .iccid-list-item:last-child {}

  }




  .main {
    position: absolute;
    top: 240px;
    left: 0;

    .content-top {
      width: 100%;
      padding: 20px 20px;
      padding-bottom: 0;

      .main-top {
        padding: 5px 10px;
        margin-bottom: 10px;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgb(218, 218, 218);
        border-radius: 5px;

        .first-line {
          flex-wrap: wrap;

          p.packageName {
            width: calc(100% - 40px);

            a {
              color: rgb(25, 137, 250);
            }
          }

          p.morePackage {
            max-width: 40px;
            text-align: right;

            a {
              color: rgb(25, 137, 250);
            }
          }

          p.time-line {
            flex-wrap: 4;
            line-height: 24px;
          }

        }

        .line {
          display: flex;
          margin: 0;
          padding: 0 0 5px 0;
          font-size: 0.8rem;

          p {
            margin: 0;
            height: 28px;
            line-height: 28px;
          }

          >div {
            display: flex;
            flex: 0;
            flex-direction: row-reverse;

            span {
              display: flex;
              height: 24px;
              line-height: 24px;
              text-align: right;
              max-width: 200px;
              color: #FFA941;
              font-weight: bold;
              margin-right: 5px;
            }

            .freshBtn {
              display: flex;
              position: relative;
              width: 30px;
              height: 24px;
              padding: 10px;
              border: none;


              img {
                position: absolute;
                top: 2px;
                left: 3px;
                width: 20px;
                height: 18px;
              }
            }

            .rechargeBtn {
              width: 50px;
              height: 28px;
              margin-left: 10px;
              color: #fff;
              border-radius: 3px;
              border: none;
              background: #FFAA43;
            }

          }

          .p-sim {
            width: 100%;
            line-height: 28px;
          }
        }
      }
    }

    .content-bottom {
      width: 100%;
      padding: 20px 20px;
      padding-top: 0;
      background: rgba(246, 246, 246, 1);

      .main-bottom {
        padding: 0 0 25px 0;
        background: rgba(255, 255, 255, 1);
        box-shadow: 0px 1px 4px 0px rgb(218, 218, 218);
        border-radius: 3px;

        >div {
          display: flex;
          flex-wrap: wrap;

          >div {
            width: 25%;
            display: flex;
            margin-top: 25px;
            text-align: center;

            >a {
              width: 100%;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;

              img {
                width: 46%;
              }

              >div {
                width: 20%;
                height: 1px;
                box-shadow: 0 4px 5px rgba(0, 78, 156, 0.8);
                ;
                margin-bottom: 12px;
              }

              span {
                font-size: 14px;
              }
            }
          }

        }
      }

    }


  }



  .tip {
    line-height: 24px;
    margin: 0 20px;
    padding: 10px;
    color: #c34e4e;
    background: #ffe1e1;
    border-radius: 5px;
    text-align: center;
  }

  .footer {
    display: flex;
    height: 26%;
    padding: 0 10%;
    align-items: center;
    justify-content: center;
  }



  .pkgList {
    padding: 10px 20px;

    h3 {
      margin-top: 20px;
      font-size: 14px;
      line-height: 28px;
      font-weight: bold;
    }

    ul {
      line-height: 38px;

      li {
        display: flex;
        justify-content: space-between;
        margin-bottom: 15px;

        >p {
          display: flex;
          align-items: center;
        }

        >div {

          p {
            line-height: 18px;
            font-size: 12px;
          }
        }
      }
    }

  }
}



.red-defind {
  color: #cc2b2b;
}

.green-defind {
  color: green;
}



.changePasswordPanel {
  padding: 10px;

  .icon-cross {
    position: absolute;
    right: 10px;
    font-size: 16px;
  }

  p {
    margin: 10px 16px 0 16px;
    line-height: 30px;
  }

  .confirmChangePassword {
    display: flex;
    justify-content: flex-end;
    margin-top: 20px;

    .confirmChangePasswordBtn {
      width: 80px;
      margin: 0 15px;
    }
  }

}


.home-advertisement {
  margin-top: 100px;
}


.analysisHandlerDialog {
  p {
    font-size: .9rem;
    line-height: 1.5rem;
    padding: 0 1rem;

    span {
      font-weight: bold;
    }

    a:after {
      display: block;
      content: "clear";
      height: 0;
      clear: both;
      overflow: hidden;
      visibility: hidden;
    }
  }

  p:first-child {
    padding-top: .5rem;
  }
}

.tag-read {
  font-family: inherit;
  font-size: 100%;
  line-height: 1.15;
  margin: 0;
  background-color: black;
  background: black;

}
</style>

<style>
.changePasswordPanel [class*=van-hairline]::after {
  border-color: #c4cedc;
}
</style>